import React, { createContext, useState, useContext } from 'react';

// Create the Product context
const ComparisonContext = createContext();

// Create the provider component
export const ComparisonProvider = ({ children }) => {

    const [comparisions, setComparisions] = useState([]);

    let apiBaseUrl = "https://tradebhp-v1.os1.me";

    if (window.location.hostname !== 'localhost') {
        apiBaseUrl = `https://${window.location.hostname}`;
    }



    const addComparision = (comparisions) => {
        setComparisions((prevComparisions) => {
            const newComparisions = comparisions.filter(
                (comparision) => !prevComparisions.some((existingComparision) => existingComparision.model === comparision.model)
            );
            return [...prevComparisions, ...newComparisions];
        });
    };

    const removeComparision = (comparision) => {
        setComparisions((prevComparisions) =>
            prevComparisions.filter((comparisionItem) => comparisionItem.model !== comparision.model)
        );
    };

    const updateComparison = (updatedItem) => {
        setComparisions((prevItems) =>
            prevItems.map(item => item.model === updatedItem.model ? updatedItem : item)
        );
    };

    return (
        <ComparisonContext.Provider value={{ apiBaseUrl, comparisions, addComparision, removeComparision, updateComparison }}>
            {children}
        </ComparisonContext.Provider>
    );
};

// Custom hook to use the product context
export const useComparison = () => useContext(ComparisonContext);
